/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnHttpService} from '../../../util/adn-http.service';
import {transformJsonObjectProperty} from '../../../util/adn-http-resource-transforms';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the NetworkData HTTP resource (factory product). */
export class NetworkDataResource {
}

export function createNetworkDataResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'networkdata',
    () => localUserProfile,
    undefined,
    undefined,
    transformJsonObjectProperty('data')
  );
}

export const networkDataResourceProvider = {
  provide: NetworkDataResource,
  useFactory: createNetworkDataResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

